import { Attendance, LeaveRequest } from '@/types/employee/attendance';
import dayjs from 'dayjs';

const employeeNames = [
  'Miguel Johnson', 'Sara Wilson', 'David Brown', 'Lisa Davis', 'Roberto Miller',
  'Jennifer García', 'Guillermo Rodríguez', 'María Martínez', 'Jaime Anderson', 'Patricia Taylor',
  'Juan Thomas', 'Linda Jackson', 'Miguel White', 'Bárbara Harris', 'Ricardo Martín',
  'Isabel Thompson', 'José García', 'Jennifer Martínez', 'Cristóbal Robinson', 'Jessica Clark',
  'Daniel Rodríguez', 'Amanda Lewis', 'Mateo Lee', 'Melissa Walker', 'Antonio Hall',
  'Stephanie Young', 'Marcos Allen', 'Nicole King', 'Donald Wright', 'Elena López',
  'Steven Hill', 'Sandra Scott', 'Pablo Green', 'Donna Baker', 'Andrés Adams',
  'Carol Nelson', 'Josué Carter', 'Ruth Mitchell', 'Ryan Pérez', 'Deborah Roberts',
  'Gary Turner', 'Sharon Phillips', 'Timothy Campbell', 'Cynthia Parker', 'José Evans',
  'Katherine Edwards', 'Larry Collins', 'Nancy Stewart', 'Jeffrey Sánchez', 'Betty Morris'
];

const attendanceStatuses = ['Presente', 'Ausente', 'Tardanza', 'De Licencia', 'Medio Día'];

export const attendances: Attendance[] = Array.from({ length: 30 }, (_, idx) => {
  const employeeIndex = idx % employeeNames.length;
  const statusIndex = idx % attendanceStatuses.length;
  const day = (idx % 28) + 1; // 1-28
  const month = (idx % 12) + 1; // 1-12
  const year = 2024;
  
  const checkInTime = dayjs().year(year).month(month - 1).date(day).hour(8 + Math.floor(Math.random() * 2)).minute(Math.floor(Math.random() * 60));
  const checkOutTime = dayjs().year(year).month(month - 1).date(day).hour(17 + Math.floor(Math.random() * 2)).minute(Math.floor(Math.random() * 60));
  
  return {
    id: `ATT${(idx + 1).toString().padStart(3, '0')}`,
    employee: [
      {
        id: `EMP${(employeeIndex + 1).toString().padStart(3, '0')}`,
        name: employeeNames[employeeIndex],
        checkInTime: attendanceStatuses[statusIndex] === 'Ausente' ? undefined : checkInTime,
        checkOutTime: attendanceStatuses[statusIndex] === 'Ausente' ? undefined : checkOutTime,
        status: attendanceStatuses[statusIndex] as any
      }
    ],
    day,
    month,
    year,
    notes: `Registro de asistencia para ${employeeNames[employeeIndex]} el ${day}/${month}/${year}`
  };
});

export const leaveRequests: LeaveRequest[] = Array.from({ length: 20 }, (_, idx) => {
  const employeeIndex = idx % employeeNames.length;
  const leaveTypes = ['Anual', 'Por Enfermedad', 'Sin Pago', 'Otros'];
  const leaveStatuses = ['pendiente', 'aprobado', 'rechazado'];
  
  const startDate = dayjs().add(Math.floor(Math.random() * 30), 'days').toDate();
  const endDate = dayjs(startDate).add(Math.floor(Math.random() * 7) + 1, 'days').toDate();
  
  return {
    id: `LEAVE${(idx + 1).toString().padStart(3, '0')}`,
    employee: {
      id: `EMP${(employeeIndex + 1).toString().padStart(3, '0')}`,
      name: employeeNames[employeeIndex]
    },
    startDate,
    endDate,
    type: leaveTypes[idx % leaveTypes.length] as any,
    status: leaveStatuses[idx % leaveStatuses.length] as any,
    reason: `Solicitud de licencia para ${employeeNames[employeeIndex]} - licencia ${leaveTypes[idx % leaveTypes.length]}`,
    approvedBy: leaveStatuses[idx % leaveStatuses.length] === 'aprobado' ? {
      id: 'ADM001',
      name: 'Usuario Administrador'
    } : undefined,
    approvedAt: leaveStatuses[idx % leaveStatuses.length] === 'aprobado' ? dayjs().subtract(Math.floor(Math.random() * 10), 'days').toDate() : undefined
  };
}); 